module.exports = __webpack_public_path__ + "static/media/img_nodata.246a6e6b.svg";